export {KeyboardShortcutItem as default};

/**
 * Keyboard Shortcut Item Entity
 *
 * @author      rsimoes <ruben-r-simoes@telecom.pt>
 * @copyright   Copyright (C) Sapo. All rights reserved.
 * @license     Private
 * @since       7.0.0
 */
class KeyboardShortcutItem {
    /**
     * Shorcut id
     *
     * @public
     *
     * @type {String}
     *
     * @since 7.0.0
     */
    id;

    /**
     * Key Mapping
     *
     * @public
     *
     * @type {String}
     *
     * @since 7.0.0
     */
    key;

    /**
     * Defines the shortcut delay before
     * the event can be broadcasted again
     *
     * @public
     *
     * @type {Number}
     *
     * @since 7.0.0
     */
    delay = 0;

    /**
     * Defines the interval id
     *
     * @public
     *
     * @type {Number}
     *
     * @since 7.0.0
     */
    interval;

    /**
     * Defines if event can be broadcasted
     *
     * @public
     *
     * @type {Boolean}
     *
     * @since 7.0.0
     */
    blocked = false;

    /**
     * Metas Keys
     *
     * @public
     *
     * @type {Array}
     *
     * @since 7.0.0
     */
    metas;

    /**
     * Callback Function
     *
     * @public
     *
     * @type {Function}
     *
     * @since 7.0.0
     */
    callback;

    /**
     * Sets a  blocked timeout
     *
     * When blocked is set to true, the callback will not be called until the delay is over
     * and the block is lifted
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {void}
     */
    setBlockedTimeout() {
        this.blocked = true;

        this.interval = setTimeout(() => {
            this.clearBlockedTimeout();
        }, this.delay)
    }

    /**
     * Clears the blocked timeout
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {void}
     */
    clearBlockedTimeout() {
        clearTimeout(this.interval);
        this.blocked  = false;
        this.interval = null;
    }
}
